import { IUser } from "../../../../types/models/user.models.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  social: IUser;
}

interface IBody {
  email: string;
}
export function useInviteAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/users/invite-admin",
  });
}
